var __jsx = React.createElement;
import React, { useState } from "react";
import { isValidPattern, hasInvalidNumericCharacters, isOutOfRange, getRangeErrorMessage, getInvalidCharacterMessage, allowsDecimals as checkAllowsDecimals, getInputBorderAndBackgroundClasses } from "../../../utils/fieldValidation";
import classNames from "classnames";
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import AwesomeIcon from "../../AwesomeIcon";
var NumberInput = function NumberInput(_ref) {
  var value = _ref.value,
    placeholder = _ref.placeholder,
    onChange = _ref.onChange,
    pattern = _ref.pattern,
    formatHint = _ref.formatHint,
    maxLength = _ref.maxLength,
    minValue = _ref.minValue,
    maxValue = _ref.maxValue,
    disabled = _ref.disabled,
    isEmpty = _ref.isEmpty,
    isRequired = _ref.isRequired,
    errorMessage = _ref.errorMessage,
    isShouldBeBlankError = _ref.isShouldBeBlankError;
  var _useState = useState(null),
    error = _useState[0],
    setError = _useState[1];
  var patternStr = pattern !== null && pattern !== void 0 ? pattern : undefined;

  // Convert value to string for display
  var stringValue = (value === null || value === void 0 ? void 0 : value.toString()) || "";

  // Check if pattern supports decimals
  var allowsDecimals = checkAllowsDecimals(patternStr);
  var shouldShowServerError = !isEmpty && !!errorMessage;
  var shouldShowError = !!error || shouldShowServerError;
  var borderAndBackgroundClasses = getInputBorderAndBackgroundClasses(shouldShowError, isRequired !== null && isRequired !== void 0 ? isRequired : false, isEmpty !== null && isEmpty !== void 0 ? isEmpty : false);
  var handleChange = function handleChange(e) {
    var newValue = e.target.value;

    // Allow empty string
    if (newValue === "") {
      setError(null);
      onChange(newValue);
      return;
    }

    // Build validation rules
    var isValid = true;

    // Only allow numeric characters, decimal point (if allowed), and minus sign
    var allowedChars = allowsDecimals ? /^[\d.\-]+$/ : /^[\d\-]+$/;
    if (!allowedChars.test(newValue)) {
      isValid = false;
    }

    // Minus sign can only be at the start
    if (newValue.includes("-") && newValue.indexOf("-") !== 0) {
      isValid = false;
    }

    // Only one minus sign allowed
    if ((newValue.match(/-/g) || []).length > 1) {
      isValid = false;
    }

    // Only one decimal point allowed (if decimals are allowed)
    if (allowsDecimals && (newValue.match(/\./g) || []).length > 1) {
      isValid = false;
    }

    // Decimal point not allowed if pattern doesn't support it
    if (!allowsDecimals && newValue.includes(".")) {
      isValid = false;
    }
    if (isValid) {
      setError(null);
      onChange(newValue);
    }
  };
  var handleClear = function handleClear(e) {
    e.preventDefault();
    e.stopPropagation();
    onChange("");
    setError(null);
  };
  var handleBlur = function handleBlur() {
    // Trim whitespace on blur
    if (stringValue && stringValue.trim() !== stringValue) {
      var trimmedValue = stringValue.trim();
      onChange(trimmedValue);
    }

    // Use trimmed value for validation
    var valueToValidate = stringValue ? stringValue.trim() : stringValue;
    if (valueToValidate) {
      // Check for invalid characters first (if pattern exists)
      if (patternStr && hasInvalidNumericCharacters(valueToValidate, allowsDecimals, patternStr)) {
        setError(getInvalidCharacterMessage(allowsDecimals, patternStr, formatHint !== null && formatHint !== void 0 ? formatHint : undefined));
      } else if (patternStr && !isValidPattern(valueToValidate, patternStr)) {
        // Check if value matches the full pattern (if pattern exists)
        setError(formatHint ? "Format: ".concat(formatHint) : "Invalid format");
      } else if (isOutOfRange(valueToValidate, minValue, maxValue)) {
        // Always check range if minValue or maxValue is defined
        setError(getRangeErrorMessage(minValue, maxValue));
      } else {
        setError(null);
      }
    } else {
      setError(null);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("w-full rounded-lg focus-within:ring-1 focus-within:ring-teal-400 dark:focus-within:ring-teal-500 relative", {
      "opacity-60": disabled
    })
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    inputMode: "decimal",
    value: stringValue,
    placeholder: placeholder,
    maxLength: maxLength !== null && maxLength !== void 0 ? maxLength : undefined,
    disabled: disabled,
    className: classNames("w-full h-[40px] px-4 py-3 border rounded-lg bg-white dark:bg-gray-900 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:!border-teal-500 dark:focus:!border-teal-400", borderAndBackgroundClasses, {
      "cursor-not-allowed": disabled,
      "pr-10": stringValue && !disabled
    }),
    onChange: handleChange,
    onBlur: handleBlur
  }), stringValue && !disabled && /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleClear,
    className: "absolute right-4 top-1/2 transform-none -translate-y-1/2 text-gray-500 dark:text-gray-400 hover:text-gray-600 dark:hover:text-gray-500 focus:outline-none",
    "aria-label": "Clear input"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    size: "sm"
  }))), (error || shouldShowServerError) && /*#__PURE__*/React.createElement("div", {
    className: "mt-1 ml-2 text-left text-red-600 dark:text-red-400 text-sm"
  }, error || errorMessage), !error && !shouldShowServerError && formatHint && !isValidPattern(stringValue, patternStr) && /*#__PURE__*/React.createElement("div", {
    className: "mt-1 ml-2 text-left text-gray-600 dark:text-gray-400 text-sm"
  }, formatHint));
};
export default NumberInput;